/** Keys shared by domain/recipient/admin auth flows in the browser. */
const authKeys = [
  'accessToken',
  'accessTokenExpiresIn',
  'refreshToken',
  'refreshTokenExpiresIn',
] as const;

export function readAccessToken(): string | null {
  return localStorage.getItem('accessToken');
}

export function readRefreshToken(): string | null {
  return localStorage.getItem('refreshToken');
}

export function clearAuthTokenKeys(): void {
  for (const k of authKeys) {
    sessionStorage.removeItem(k);
    localStorage.removeItem(k);
  }
}

/** Profile JSON is stored alongside tokens in localStorage. */
export function writeProfileJson(json: string): void {
  localStorage.setItem('profile', json);
}

export function readProfileRaw(): string {
  return localStorage.getItem('profile') ?? '{}';
}

export function clearProfileKeys(): void {
  sessionStorage.removeItem('profile');
  localStorage.removeItem('profile');
}
